import axios from 'axios';
// axios.defaults.baseURL = 'https://chat.careerroshi.com/'
axios.defaults.baseURL = 'https://roshi-chat.herokuapp.com/'
// axios.defaults.baseURL = 'http://localhost:4000/'



export default axios;